exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "a,a:focus,a:hover{text-decoration:none}a:focus,a:hover{color:#565666}p a{text-decoration:underline}.row-title{border-bottom:1px solid #e5dada;text-align:center;margin-top:9px;margin-bottom:32px}.row-title h2{font-size:1.35em}.row-title>*{color:#0c0c0c;font-weight:700;text-transform:uppercase;display:inline-block;font-size:14px;padding:6px 0;margin:0}.row-title.title--left{text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./~/postcss-loader!./src/typography.scss
// module id = 752
// module chunks = 0